import styled from "styled-components";
import TextareaAutosize from "react-textarea-autosize";
import { Box, utils } from "@thenounproject/lingo-core";

type InlineInputProps = {
  font?: string;
};

export const InlineInput = styled(TextareaAutosize)<InlineInputProps>`
  max-height: initial;
  min-height: initial;
  width: 100%;
  ${utils.positioningCSS({ py: "xs" })};
  ${props => utils.getFont(props.font, "ui.regular", props)}
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  resize: none;
`;

type InputContainerProps = {
  canEdit: boolean;
  isEditing: boolean;
};

export const InputContainer = styled(Box).attrs<InputContainerProps & { mx?: string; px?: string }>(
  props => {
    return {
      mx: props.mx || "-xs",
      px: props.px || "xs",
      borderRadius: "default",
      background: props.canEdit && props.isEditing ? "grayLighter" : null,
      variations: props.canEdit
        ? {
            "&:hover": {
              background: "grayLighter",
            },
          }
        : null,
      style: {
        transition: "background 0.3s ease, min-height 0.3s ease",
      },
    };
  }
)<InputContainerProps>``;
